import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';
import { whatsappConfig } from '../data/hotelData';

// --- Animations ---
const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
  70% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
  100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
`;

const slideIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

// --- Styled Components ---
const WidgetContainer = styled.a`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background-color: #25d366; /* Official WhatsApp Green */
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  z-index: 2000; /* Above Footer and Navbar */
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  animation: ${pulse} 2s infinite, ${slideIn} 0.5s ease-out;

  &:hover {
    transform: scale(1.1);
    background-color: #20b858;
    color: white;
  }

  /* Mobile Adjustments */
  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
    font-size: 28px;
  }
`;

const Tooltip = styled.span`
  position: absolute;
  right: 75px;
  background: #fff;
  color: #1a1a1a;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  opacity: 0;
  transform: translateX(10px);
  transition: all 0.3s ease;
  pointer-events: none;
  font-family: 'Lato', sans-serif;

  /* Little triangle pointing to button */
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: -6px;
    transform: translateY(-50%);
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #fff;
  }

  ${WidgetContainer}:hover & {
    opacity: 1;
    transform: translateX(0);
  }

  @media (max-width: 768px) {
    display: none; /* Hide tooltip on mobile to save space */
  }
`;

const WhatsAppWidget = () => {
  const { number, message } = whatsappConfig;
  
  // Create the API Link
  const handleClick = () => {
    const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <WidgetContainer onClick={handleClick} aria-label="Chat on WhatsApp">
      <FaWhatsapp />
      <Tooltip>Chat with us</Tooltip>
    </WidgetContainer>
  );
};

export default WhatsAppWidget;